import FeatureLayer from "@arcgis/core/layers/FeatureLayer";
import * as bufferOperator from "@arcgis/core/geometry/operators/bufferOperator.js";
import { AppConfig } from "../AppConfig";
import type { GeometryUnion } from "@arcgis/core/geometry/types";

let protectedAreaLayerInstance: FeatureLayer | null = null;

const getProtectedAreaLayer = async () => {
    if (!protectedAreaLayerInstance) {
        protectedAreaLayerInstance = new FeatureLayer({
            portalItem: {
                portal: {
                    url: AppConfig.ArcGIS.BaseUrl,
                },
                id: "93f892b419a04af88c821e08d0681476",
            },
        });
        await protectedAreaLayerInstance.load();
    }
    return protectedAreaLayerInstance;
};

const queryProtectedNatureArea = async (geometry: GeometryUnion) => {
    const protectedAreaLayer = await getProtectedAreaLayer();

    const result = await protectedAreaLayer.queryFeatureCount({
        where: "1=1",
        spatialRelationship: "intersects",
        geometry: geometry,
    });

    return result > 0;
};

const queryIntrusiveSpeciesArea = async (geometry: GeometryUnion) => {
    const intrusiveSpeciesLayer = new FeatureLayer({
        portalItem: {
            portal: {
                url: AppConfig.ArcGIS.BaseUrl,
            },
            id: "c11209527eea4479aa008a36d51215a7",
        },
        layerId: 1,
    });

    const buffer = bufferOperator.execute(geometry, 1000, {
        unit: "meters",
    });

    const result = await intrusiveSpeciesLayer.queryFeatureCount({
        spatialRelationship: "intersects",
        geometry: buffer,
    });

    return result > 0;
};

const queryIntrusiveSpeciesPoints = async (geometry: GeometryUnion) => {
    const intrusiveSpeciesLayer = new FeatureLayer({
        portalItem: {
            portal: {
                url: AppConfig.ArcGIS.BaseUrl,
            },
            id: "c11209527eea4479aa008a36d51215a7",
        },
        layerId: 0,
    });

    const buffer = bufferOperator.execute(geometry, 1000, {
        unit: "meters",
    });

    const result = await intrusiveSpeciesLayer.queryFeatureCount({
        spatialRelationship: "intersects",
        geometry: buffer,
    });

    return result > 0;
};

export const getProtectionWarningForFeature = async (
    featureGeometry: GeometryUnion | null | undefined,
    objectID: number
): Promise<{ objectID: number; warning: string }> => {
    if (!featureGeometry) {
        return { objectID: -1, warning: "" };
    }
    const protectedAreaWarning = await queryProtectedNatureArea(featureGeometry);
    const intrusiveSpeciesWarning = await queryIntrusiveSpeciesArea(featureGeometry);
    const intrusiveSpeciesPointsWarning = await queryIntrusiveSpeciesPoints(featureGeometry);
    let warning = "";

    if (protectedAreaWarning) {
        warning = "Objektet ligger innenfor et verneområde";
    }

    if (intrusiveSpeciesWarning || intrusiveSpeciesPointsWarning) {
        if (warning) {
            warning += " og innenfor eller i nærheten av et område med Havnespy (Japansk sjøpung).";
        } else {
            warning += "Objektet ligger innenfor eller i nærheten av et område med Havnespy (Japansk sjøpung).";
        }
    }

    return warning ? { objectID: objectID, warning } : { objectID: -1, warning: "" };
};
